import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import type { PersonalDetailsAnalyticsInputData } from './types';

export const useUpdatePersonalDetailsAnalytics = () => {
  const { updateCard } = useAnalytics();

  const updatePersonalDetailsAnalytics = ({
    updatedPersonalDetailsSections,
    updatedLocation,
  }: PersonalDetailsAnalyticsInputData) => {
    updateCard({
      actionName: 'EDIT',
      currentPageSection: 'personal details',
      customProps: {
        personalDetailsSections: updatedPersonalDetailsSections,
        ...(updatedLocation &&
          updatedPersonalDetailsSections.some(
            (section) => section === 'home location',
          ) && {
            locationType: updatedLocation.kind,
            locationCountry: updatedLocation.countryCode?.toLowerCase(),
          }),
      },
    });
  };

  return { updatePersonalDetailsAnalytics };
};
